<template>
    <div
        v-if="dialog"
        class="confirm-modal"
        @click.self="close()"
    >
        <div class="confirm-modal__dialog">
            <header class="confirm-modal__header">
                <h2>{{ title }}</h2>
                <span
                    class="confirm-modal__close"
                    @click="close()"
                />
            </header>
            <section class="confirm-modal__content">
                <span>{{ message }}</span>
            </section>
            <footer>
                <div class="confirm-modal__two-button-block">
                    <button
                        class="confirm-modal__two-button confirm-modal__two-button--gray"
                        @click.prevent="close()"
                    >
                        cancel
                    </button>
                    <button
                        class="confirm-modal__two-button confirm-modal__two-button--main"
                        @click.prevent="submit()"
                    >
                        ok
                    </button>
                </div>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ConfirmModal',
    data: () => ({
        dialog: false,
        resolve: null,
        reject: null,
        message: null,
        title: null
    }),
    methods: {
        open(title, message) {
            this.dialog = true
            this.title = title
            this.message = message
            return new Promise((resolve, reject) => {
                this.resolve = resolve
                this.reject = reject
            })
        },
        submit() {
            this.resolve(true)
            this.dialog = false
        },
        close() {
            this.resolve(false)
            this.dialog = false
        }
    }
}
</script>

<style lang="scss">
.confirm-modal {
    position: fixed;
    overflow: hidden;
    background-color: rgba(11, 19, 31, .45);
    backdrop-filter: blur(3px);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    height: 100vh;
    overscroll-behavior: contain;
    z-index: 900;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;

    &__dialog {
        max-width: 400px;
        width: 100%;
        background-color: #fff;
        -webkit-box-shadow: 0 10px 40px rgba(25, 50, 71, .2);
        box-shadow: 0 10px 40px rgba(25, 50, 71, .2);
        border-radius: $input-border-radius;
        top: 90px;
        left: calc(50% - 250px);
        z-index: 999999999;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    &__header {
        font-weight: 500;
        color: $font-color-main;
        font-size: 24px;
        border-bottom: 1px solid $border-light;
        padding: 20px;
        position: relative;
    }
    &__close {
        position: absolute;
        right: 20px;
        top: 50%;
        min-width: 14px;
        width: 14px;
        height: 14px;
        background: url("~@/assets/img/svg/close.svg") no-repeat;
        background-size: contain;
        transform: translateY(-50%);
        color: #4F4F4F;
        cursor: pointer;
    }
    &__content {
        padding: 20px 20px 0;
        color: #757c89;
        font-size: 16px;
        line-height: 1.3;
    }
    &__two-button-block {
        display: flex;
        justify-content: space-between;
        padding: 20px;
    }
    &__one-button-block {
        display: flex;
        justify-content: center;
        padding: 20px;
        button {
            text-transform: capitalize;
        }
    }
    &__two-button {
        padding: 15px 0;
        width: calc(50% - 10px);
        text-transform: uppercase;
        font-size: 16px;
        font-weight: bold;
        border: none;
        border-radius: $input-border-radius;
        cursor: pointer;
        &--gray {
            background-color: #f5f5f5;
            &:hover {
                background-color: rgba(145, 149, 154, 0.2);
                transition: 0.5s;
            }
        }
        &--main {
            background: #1976D2;
            box-shadow: 0 10px 20px -5px rgba(196,74,0,.6);
            color: white;
            //&:hover {
            //    background: linear-gradient(94.79deg, #FF5925 0.59%, #FF9D39 98.53%), #1161E0;
            //    transition: 0.5s;
            //}
        }
    }
    &__one-button {
        padding: 20px 0;
        width: 80%;
        text-transform: uppercase;
        font-size: 16px;
        font-weight: bold;
        border: none;
        border-radius: $input-border-radius;
        cursor: pointer;
        &--main {
            background: linear-gradient(94.79deg, #FF9D39 0.59%, #FF5925 98.53%), #1161E0;
            box-shadow: 0 10px 20px -5px rgba(196,74,0,.6);
            color: white;
            //&:hover {
            //    background: linear-gradient(94.79deg, #FF5925 0.59%, #FF9D39 98.53%), #1161E0;
            //    transition: 0.5s;
            //}
        }

    }
}
@media (max-width: 480px) {
    .confirm-modal {
        & .confirm-modal__content {
            padding: 15px 15px 0;
        }
        & .confirm-modal__two-button-block {
            padding: 15px;
        }
    }
}
</style>
